import { InjectionToken } from '@angular/core';

export interface AppConfig {
  debounceTime: number;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');
